module.exports = __webpack_public_path__ + "img/whole.b49b8ba2.png";